import * as React from 'react';
import { Autocomplete as MuiAutocomplete, Popper, PopperProps } from '@mui/material';
import {
  AutocompleteProps as MuiAutocompleteProps,
  AutocompleteRenderInputParams as RenderInputParams,
} from '@mui/material/Autocomplete';
import TextField, { TextFieldProps } from 'ui/TextField';

export interface AutocompleteProps<T>
  extends Omit<MuiAutocompleteProps<T, false, false, false>, 'renderInput'> {
  autofocus?: boolean;
  label?: string;
  renderInput?(params: RenderInputParams): JSX.Element;
  TextFieldProps?: Optional<TextFieldProps>;
  onChange(changeEvent: React.ChangeEvent<{}>, value: T | null): void;
  defaultValue?: T;
  defaultPopper?: boolean;
}

/**
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
function Autocomplete<T>({
  autofocus = false,
  label,
  TextFieldProps,
  defaultPopper,
  ...rest
}: AutocompleteProps<T>) {
  const NoPortalPopper = (props: PopperProps) => {
    const { children } = props;
    return (
      <Popper
        {...props}
        placement="bottom"
        disablePortal
        modifiers={[
          { name: 'flip', enabled: true },
          {
            name: 'preventOverflow',
            options: {
              enabled: true,
              boundariesElement: 'scrollParent',
              escapeWithReference: true,
            },
          },
        ]}
      >
        {children}
      </Popper>
    );
  };

  return (
    <MuiAutocomplete<T>
      autoComplete
      renderInput={(params) => (
        <TextField {...params} label={label} autoFocus={autofocus} {...TextFieldProps} />
      )}
      PopperComponent={defaultPopper ? NoPortalPopper : undefined}
      {...rest}
    />
  );
}

export default Autocomplete;
